import { ReactNode } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import styled from 'styled-components';
import classNames from 'classnames';

interface DroppableZoneProps {
  id: string;
  children: ReactNode;
  items: any[];
}

const StyledDropZone = styled.div`
  min-height: 200px;
  width: 100%;
  transition: background-color 0.2s ease;

  &.is-over {
    background-color: rgba(33, 150, 243, 0.08);
    border: 2px dashed #2196f3;
    border-radius: 8px;
  }
`;

export const DroppableZone = ({ id, children, items }: DroppableZoneProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
  });

  return (
    <StyledDropZone ref={setNodeRef} className={classNames({ 'is-over': isOver })}>
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </StyledDropZone>
  );
};
